import './technology-for-me.scss';
import React, { useMemo, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { 
    Box, 
    Button
} from '@material-ui/core';
import auraImg from '../../../../assets/img/aura.svg';
import spaceAuraImg from '../../../../assets/img/space-aura.svg';
import { UserProfileContext } from '../../../../context/user-profile.context';

function TechnologyForMe() {

    const [userProfileData] = React.useContext(UserProfileContext);
    const [techQuiz, setTechQuiz] = useState<boolean | null>(null);

    useMemo(() => {
        if ( userProfileData?.quiz ) {
            
            const techQuiz = userProfileData.quiz.find((item: any) => item.type === 'tech');
            if ( techQuiz ) {
                setTechQuiz(true);
            }
        }
    }, [userProfileData]);

    return (
        <Box className="technology-for-me">
            <h1>
                Products for me
                <NavLink to="/profile/settings">
                    <span className="icon-settings"></span>
                </NavLink>
            </h1>

            <Box className="content">

                <Box className="image-box">
                    <img className="venue-photo" src={techQuiz ? spaceAuraImg : auraImg} />
                </Box>

                <p>
                    What do you use your ear technology for?<br />
                    <NavLink to="/profile/tech-quiz">Answer a few questions</NavLink> to get personalized<br />
                    recommendations for technology.

                </p>

                <NavLink to="/profile/tech-quiz">
                    <Button className="btn-gradient">Go to the questions</Button>
                </NavLink>
            </Box>
        </Box>
    );

}

export default TechnologyForMe;


